import React, { memo } from 'react';
import { AuthorisationConsumer, RequestProvider } from '@shootsta/common-react';
import { duplicateVideoApi } from '../../../api';
import DuplicateModalComponent from '../components/DuplicateModal';

type DuplicateModalProps = {
  video?: Video;
  visible: boolean;
  onConfirmation: any;
  onClose: any;
};

function DuplicateModal(props: DuplicateModalProps) {
  return (
    <AuthorisationConsumer requiresOrganisation>
      {({ selectedOrganisation: { name } }) => (
        <RequestProvider
          requests={{
            duplicateVideo: duplicateVideoApi
          }}
        >
          {(requests) => (
            <DuplicateModalComponent
              organisationName={name}
              {...requests}
              {...props}
            />
          )}
        </RequestProvider>
      )}
    </AuthorisationConsumer>
  );
}

export default memo<DuplicateModalProps>(DuplicateModal);
